export interface TariffPlan {
    planId: number | string;
    code: number | string;
    description: string;
    details?: string;
    notes?: string;
    active: boolean;
    preauthorizationAmount: number;
    reservationTimeout?: number;
    reservationPenaltyCost?: number;
    unlockCost?: number;
    kmCost?: number;
    minCost?: number;
    pauseCost?: number;
    maxRideDuration?: number;
    extraMinutePenaltyCost?: number;
    maxRideDistance?: number;
    extraKmPenaltyCost?: number;
    minPrice?: number;
    maxPrice?: number;
    freeMins?: number
    freeKm?: number;
    models: string[] | null;
}

export interface PublicTariffPlan {
    planId: number | string;
    code: number | string;
    description: string;
    details?: string;
    active: boolean;
    preauthorizationAmount: number;
    reservationTimeout?: number;
    reservationPenaltyCost?: number;
    unlockCost?: number;
    kmCost?: number;
    minCost?: number;
    pauseCost?: number;
    maxRideDuration?: number;
    extraMinutePenaltyCost?: number;
    maxRideDistance?: number;
    extraKmPenaltyCost?: number;
    minPrice?: number;
    maxPrice?: number;
    freeMins?: number
    freeKm?: number;
}

export interface TariffPlanFilter {
    options: {
        active: boolean
    },
    cache: {
        active: boolean
    },
    values: {
        active?: boolean | undefined
    },
    applied: {
        active?: boolean
    }
}


export function getDefaultTariffPlan(): TariffPlan {
    return structuredClone({
        planId: '',
        code: '',
        description: '',
        active: true,
        preauthorizationAmount: 1,
        models: null
    })
}